import React from 'react'
import ContactUs from '../feature/ContactUs/ContactUs'

const ContactUsPage = () => {
  return <ContactUs/>
}

export default ContactUsPage